import {
	Button,
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	RootDialogProps,
} from "@dune/ui";
import { FormProvider } from "react-hook-form";
import { ContactForm } from "./ContactForm";
import { useAddContactForm } from "./useAddContactForm";

export const AddContactDialog = (props: RootDialogProps) => {
	const { onSubmit, isLoading, formMethods } = useAddContactForm(() => {
		props.onOpenChange?.(false);
	});
	return (
		<Dialog {...props}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Ajouter un contact</DialogTitle>
				</DialogHeader>
				<FormProvider {...formMethods}>
					<ContactForm mode="add" />
				</FormProvider>
				<DialogFooter>
					<Button onClick={() => props.onOpenChange?.(false)}>Annuler</Button>
					<Button onClick={onSubmit()} isLoading={isLoading}>
						Ajouter
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
